import { api, setToken } from "./client";
import store from "../store";
import router from "../router";

async function authenticate({ body, redirect }) {
    // Try to set initial token.
    setToken(store.state.token);

    const { data } = await api.post(
        "/api/account/login",
        {
            site: window.location.hostname,
            ...body
        }
    );

    if (data && data.authenticated) {
        store.commit("login", data);
        setToken(data.token);
    } else {
        store.commit("logout");
        setToken("");

        if (redirect) {
            router.push(redirect);
        }
    }

    return { data };
}

export { authenticate }